import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { translate } from 'react-i18next';
import { GridColumn as Column } from '@progress/kendo-react-grid';

import Table from '../common/Table';
import StringCell from '../common/formatters/StringCell';
import Translation from '../common/Translation';
import EnumCell from '../common/formatters/EnumCelll';
import Alerts from '../common/Alerts';
import ActionButton from '../common/ActionButton';
import { navigateTo } from '../../actions/navigationActions';
import { TEXT_HORIZONTAL_ALIGN, NAVIGATION_PATHS } from '../../common/constants';
import { nameofFactory } from '../../helpers/nameOfFactory';
import EventTriggerConfiguration from '../../entities/eventTriggerConfiguration';
import NavigableCell from '../common/formatters/navigableCell';
import { EVENTTRIGGERCONFIGURATION } from '../../data-transformations/dataTransformationTypes';
import { BaseListDispatchProps, BaseListProps } from '../common/types/baseDetail';
import * as enums from '../../common/enums';
import DateCell from '../common/formatters/DateCell';

const nameof = nameofFactory<EventTriggerConfiguration>();

const actionUrl = 'eventtriggerconfigurations';

interface EventTriggerConfigurationProps extends BaseListProps {}

const EventTriggerConfigurations = ({ t, navigateTo }: EventTriggerConfigurationProps) => {
    let table: any;

    const onNew = () => {
        navigateTo(NAVIGATION_PATHS.EVENTTRIGGERCONFIGURATION_CREATE);
    };

    const onEdit = () => {
        table.getWrappedInstance().editSelected();
    };

    const onRemove = () => {
        table.getWrappedInstance().removeSelected();
    };

    return (
        <div>
            <div className="content-header">
                <h1>
                    <Translation tKey="EventTriggerConfigurations" />
                </h1>
            </div>
            <div className="content-wrapper">
                <Alerts />
                <div className="panel">
                    <div className="panel-header">
                        <div className="actions">
                            <ActionButton text="Add" onClick={onNew} icon="plus" />
                            <ActionButton text="Edit" onClick={onEdit} icon="pencil" selection="one" />
                            <ActionButton text="Remove" onClick={onRemove} icon="delete" selection="multi" />
                        </div>
                        <div className="filter" />
                    </div>
                    <div className="panel-content">
                        <Table
                            path={'eventtriggerconfiguration'}
                            actionPath={actionUrl}
                            selectedField="selected"
                            ref={(el) => {
                                table = el;
                            }}
                            name="LinkTable"
                            dataTransformation={EVENTTRIGGERCONFIGURATION}
                        >
                            <Column field="selected" width="50" />
                            <Column
                                field={nameof('name')}
                                cell={(props) => (
                                    <NavigableCell
                                        {...props}
                                        actionUrl={actionUrl}
                                        navigateTo={navigateTo}
                                        component={StringCell(TEXT_HORIZONTAL_ALIGN.LEFT)}
                                    />
                                )}
                                title={t('Name')}
                            />
                            <Column
                                field={nameof('sourceEnumDescription')}
                                width="100"
                                cell={(props) => (
                                    <NavigableCell
                                        {...props}
                                        actionUrl={actionUrl}
                                        navigateTo={navigateTo}
                                        component={EnumCell(enums.EVENT_TRIGGER_CONFIGURATION_SOURCE_TYPES)}
                                    />
                                )}
                                title={t('Source')}
                            />
                            <Column field={nameof('validFromUtc')} cell={DateCell} title={t('ValidFrom')} />
                            <Column field={nameof('validToUtc')} cell={DateCell} title={t('ValidTo')} />
                            <Column field={nameof('onlyForBetaTesters')} cell={DateCell} title={t('OnlyForBetaTesterslidTo')} />
                            {/* <Column
                                field={nameof('value')}
                                cell={(props) => (
                                    <NavigableCell
                                        {...props}
                                        actionUrl={actionUrl}
                                        navigateTo={navigateTo}
                                        component={StringCell(TEXT_HORIZONTAL_ALIGN.LEFT)}
                                    />
                                )}
                                title={t('Value')}
                            />
                            <Column
                                field={nameof('typeEnumDescription')}
                                width="100"
                                cell={(props) => (
                                    <NavigableCell
                                        {...props}
                                        actionUrl={actionUrl}
                                        navigateTo={navigateTo}
                                        component={EnumCell(enums.LINK_TYPE_TYPES)}
                                    />
                                )}
                                title={t('Type')}
                            /> */}
                        </Table>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapDispatchToProps = (dispatch: Dispatch<any>): BaseListDispatchProps => {
    return {
        navigateTo: bindActionCreators(navigateTo, dispatch),
    };
};

export default compose(connect(null, mapDispatchToProps), translate('common'))(EventTriggerConfigurations);
